export const simplifiedAreaComparison = {
  "universities": [
    "Imperial College London",
    "University of Oxford",
    "University of Cambridge",
    "London Business School",
    "University of Manchester"
  ],
  "category": "MBA",
  "model": "chatgpt",
  "metrics": [
    "academic_reputation",
    "faculty_quality",
    "program_structure",
    "admission_selectivity",
    "tuition_costs",
    "financial_aid",
    "career_outcomes",
    "student_life",
    "industry_connections",
    "international_support"
  ],
  "comparison_data": [
    {
      "name": "Imperial College London",
      "academic_reputation": 92,
      "faculty_quality": 89,
      "program_structure": 88,
      "admission_selectivity": 91,
      "tuition_costs": 78,
      "financial_aid": 82,
      "career_outcomes": 94,
      "student_life": 85,
      "industry_connections": 91,
      "international_support": 89
    },
    {
      "name": "University of Oxford",
      "academic_reputation": 95,
      "faculty_quality": 93,
      "program_structure": 90,
      "admission_selectivity": 94,
      "tuition_costs": 82,
      "financial_aid": 85,
      "career_outcomes": 96,
      "student_life": 88,
      "industry_connections": 89,
      "international_support": 92
    },
    {
      "name": "University of Cambridge",
      "academic_reputation": 94,
      "faculty_quality": 92,
      "program_structure": 89,
      "admission_selectivity": 93,
      "tuition_costs": 80,
      "financial_aid": 84,
      "career_outcomes": 95,
      "student_life": 87,
      "industry_connections": 88,
      "international_support": 91
    },
    {
      "name": "London Business School",
      "academic_reputation": 90,
      "faculty_quality": 88,
      "program_structure": 92,
      "admission_selectivity": 89,
      "tuition_costs": 85,
      "financial_aid": 78,
      "career_outcomes": 97,
      "student_life": 90,
      "industry_connections": 95,
      "international_support": 94
    },
    {
      "name": "University of Manchester",
      "academic_reputation": 85,
      "faculty_quality": 83,
      "program_structure": 82,
      "admission_selectivity": 81,
      "tuition_costs": 75,
      "financial_aid": 80,
      "career_outcomes": 87,
      "student_life": 84,
      "industry_connections": 85,
      "international_support": 83
    }
  ],
  "evidence_sources": [
    {
      "category": "comparison_analysis",
      "source": "University Comparison Database",
      "confidence": 0.92,
      "url": "https://www.topuniversities.com",
      "snippet": "Comprehensive comparison data for MBA programs across top universities.",
      "type": "ranking_platform",
      "domain": "education"
    },
    {
      "category": "roi_analysis",
      "source": "Graduate Employment Survey",
      "confidence": 0.88,
      "url": "https://www.hesa.ac.uk/data-and-analysis/graduates",
      "snippet": "Employment outcomes and salary data for MBA graduates.",
      "type": "governmental",
      "domain": "employment"
    }
  ],
  "recommendations": [
    {
      "category": "program_selection",
      "issue": "Program Fit Assessment",
      "recommendation": "Consider program specialization and industry connections when selecting MBA programs",
      "priority": "High",
      "expected_impact": "Better alignment with career goals and industry requirements"
    },
    {
      "category": "financial_planning",
      "issue": "Cost-Benefit Analysis",
      "recommendation": "Evaluate tuition costs against expected career outcomes and salary increases",
      "priority": "Medium",
      "expected_impact": "Improved financial planning and ROI expectations"
    }
  ],
  "metrics_count": 10,
  "note": "Course ROI Comparison - Simplified comparison with 10 key metrics for better readability and decision making"
};
